<template>
  <div>
    <app-header></app-header>
    <div class='section'>
        <h1 class="title has-text-centered">
            Python API token: {{ auth_token }}
        </h1>
        <h1 class="title has-text-centered">
            Slack Username: {{ den_user_slack_username }}
        </h1>
        <h1 class="title has-text-centered">
            Slack Email: {{ den_user_email }}
        </h1>

    </div>
  </div>
</template>

<script>

    // import global event bus which can be used over multiple routes/components
    import { eventBus } from '../main';
    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'

    export default {
        mixins: [GetAxiosAuthConfig],
        data() {
            return {
                auth_token: '',
                den_user_slack_username: '',
                den_user_email: '',
            }
        },
        mounted() {
            this.auth_token = axios_auth_config.headers.Authorization.split(" ")[1]
            this.den_user_slack_username = localStorage.getItem('den_user_slack_username'),
            this.den_user_email = localStorage.getItem('den_user_email'),
            console.log('localStorage.auth_token:', this.auth_token)
        },
    }

</script>

<style scoped lang="scss">
    // this should inherit from App.vue but I dont know how
    $den_offwhite: #dddbd4;

    .title {
        color: $den_offwhite;
    }
</style>